import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ISO_MATERIAL_FORM_LIST,
  ISO_MATERIAL_FORM_LIST_FILTER,
  ISO_WELD_LOG_FORM_LIST,
  NCR_REPORT_FORM_LIST_FILTER,
  NCR_REPORT_LIST,
  PROJECT_REPORT_FORM_LIST_FILTER,
  PROJECT_REPORT_LIST,
  WELD_LOG_FORM_LIST_FILTER,
  WELDING_GAS_FORM_LIST,
  WELDING_GAS_FORM_LIST_FILTER,
  WELDING_MACHINE_CALLIBRATION_LIST,
  WELDING_MACHINE_FORM_LIST_FILTER,
  WELDING_WPQ_FORM_LIST_FILTER,
  WELDING_WPQ_LIST,
} from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchIsoMaterialFilterListStart,
  fetchIsoMaterialFilterListSuccess,
  fetchIsoMaterialFilterListFailure,
  fetchWeldLogFilterListStart,
  fetchWeldLogFilterListSuccess,
  fetchWeldLogFilterListFailure,
  fetchWeldingMachineFilterListStart,
  fetchWeldingMachineFilterListSuccess,
  fetchWeldingMachineFilterListFailure,
  fetchWeldingWPQFilterListStart,
  fetchWeldingWPQFilterListSuccess,
  fetchWeldingWPQFilterListFailure,
  fetchWeldingGasFilterListStart,
  fetchWeldingGasFilterListSuccess,
  fetchWeldingGasFilterListFailure,
  fetchNcrReportFilterListStart,
  fetchNcrReportFilterListSuccess,
  fetchNcrReportFilterListFailure,
  fetchProjectReportFilterListStart,
  fetchProjectReportFilterListSuccess,
  fetchProjectReportFilterListFailure,
} from "../../reducer/FilterReducer/InspectionFilterReducer";
import {
  fetchIsoMaterialFilterSuccess,
  fetchIsoMaterialFilterFailure,
  fetchWeldingGasFilterSuccess,
  fetchWeldingGasFilterFailure,
  fetchWeldingMachineFilterSuccess,
  fetchWeldingMachineFilterFailure,
  fetchWeldingWPQFilterSuccess,
  fetchWeldingWPQFilterFailure,
  fetchWeldingLogFilterSuccess,
  fetchWeldingLogFilterFailure,
  fetchNcrReportFilterSuccess,
  fetchNcrReportFilterFailure,
  fetchProjectReportFilterSuccess,
  fetchProjectReportFilterFailure,
} from "../../reducer/InspectonDetailReducer/InspectionDetailReducer";


const FORM_STATUS = {
  OPEN: 0,
  COMPLETE: 1,
  DELETE: 2,
  ISSUE: 3,
  TOP_READY: 4,
};

const constructParams = (filters, projectId) => {
  const params = { project_id: projectId };

    if (filters.status && filters.status.length > 0) {
      filters.status.forEach((status, index) => {
        console.log("status", status)
        const upperStatus = status.toUpperCase();
        if (upperStatus === "TOP READY") {
          params[`form_status[${index}]`] = FORM_STATUS.TOP_READY;
        } else if (FORM_STATUS[upperStatus] !== undefined) {
          params[`form_status[${index}]`] = FORM_STATUS[upperStatus];
        }
        // if (FORM_STATUS[upperStatus] !== undefined) {
        //   params[`form_status[${index}]`] = FORM_STATUS[upperStatus];
        // }
      });
    }
  if (filters.dateRange) {
    params["start_date"] = filters.dateRange.start || "";
    params["end_date"] = filters.dateRange.end || "";
  }

  const fields = [
    "inspectors_name",
    "size_id",
    "loc_id",
    "surface_name",
    "tag_id",
    "receiving",
    "description_id",
    "heat",
    "lot_number",
    "serial_number",
    "accept_criteria",
    "ref_number",
    "line",
    "cert_id",
    "welder_id",
    "name",
    "p_id",
    "line_no",
    "system",
    "iso_draw_no",
    "equipment_id",
    "mechanical_contractor",
    "classification",
    "material_type",
  ];

  fields.forEach((field) => {
    if (filters[field] && filters[field].length > 0) {
      filters[field].forEach((item, index) => {
        params[`${field}[${index}]`] = item;
      });
    }
  });

  return params;
};


export const sendMaterialFilterData = createAsyncThunk(
  "inspection/materialFilter",
  async ({ projectId, filters }, { dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(ISO_MATERIAL_FORM_LIST, {
        params,
      });
      dispatch(fetchIsoMaterialFilterSuccess(response.data)); 
      return response.data;
    } catch (error) {
      dispatch(
        fetchIsoMaterialFilterFailure(
          error.response?.data || "An error occurred"
        )
      ); 
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);


export const sendWeldingGasFilterData = createAsyncThunk(
  "inspection/weldingGasFilter",
  async ({ projectId, filters }, {dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(WELDING_GAS_FORM_LIST, {
        params,
      });
      dispatch(fetchWeldingGasFilterSuccess(response.data)); 
      return response.data;
    } catch (error) {
       dispatch(
        fetchWeldingGasFilterFailure(
          error.response?.data || "An error occurred"
        )
      ); 
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);


export const sendMachineCertificationFilterData = createAsyncThunk(
  "inspection/machineCertificationFilter",
  async ({ projectId, filters }, { dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(
        WELDING_MACHINE_CALLIBRATION_LIST,
        { params }
      );
       dispatch(fetchWeldingMachineFilterSuccess(response.data)); 
      return response.data;
    } catch (error) {
       dispatch(
        fetchWeldingMachineFilterFailure(
          error.response?.data || "An error occurred"
        )
      );
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);


export const sendWeldingOperatorFilterData = createAsyncThunk(
  "inspection/weldingOperatorFilter",
  async ({ projectId, filters }, {dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(WELDING_WPQ_LIST, { params });
      dispatch(fetchWeldingWPQFilterSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(
        fetchWeldingWPQFilterFailure(
          error.response?.data || "An error occurred"
        )
      );
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const sendIsoMetricWeldLogFilterData = createAsyncThunk(
  "inspection/isoMetricWeldLogFilter",
  async ({ projectId, filters }, {dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(ISO_WELD_LOG_FORM_LIST, {
        params,
      });
       dispatch(fetchWeldingLogFilterSuccess(response.data));
      return response.data;
    } catch (error) {
        dispatch(
        fetchWeldingLogFilterFailure(
          error.response?.data || "An error occurred"
        )
      );
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);


export const sendNcrReportFilterData = createAsyncThunk(
  "inspection/ncrReportFilter",
  async ({ projectId, filters }, {dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(NCR_REPORT_LIST, { params });
      dispatch(fetchNcrReportFilterSuccess(response.data));
      return response.data;
    } catch (error) {
        dispatch(
        fetchNcrReportFilterFailure(
          error.response?.data || "An error occurred"
        )
      );
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);


export const sendProjectReportFilterData = createAsyncThunk(
  "inspection/projectReportFilter",
  async ({ projectId, filters }, {dispatch, rejectWithValue }) => {
    try {
      const params = constructParams(filters, projectId);
      const response = await axiosInstance.get(PROJECT_REPORT_LIST, { params });
      dispatch(fetchProjectReportFilterSuccess(response.data));
      return response.data;
    } catch (error) {
       dispatch(
        fetchProjectReportFilterFailure(
          error.response?.data || "An error occurred"
        )
      );
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const filterActions = [
  sendMaterialFilterData,
  sendWeldingGasFilterData,
  sendMachineCertificationFilterData,
  sendWeldingOperatorFilterData,
  sendIsoMetricWeldLogFilterData,
  sendProjectReportFilterData,
  sendNcrReportFilterData,
];

let isFetchingIsoMaterialFilterList = false;
let isFetchingWeldingMachineFilterList = false;
let isFetchingWeldLogFilterList = false;
let isFetchingWeldingWPQFilterList = false;
let isFetchingWeldingGasFilterList = false;
let isFetchingNcrReportFilterList = false;
let isFetchingProjectReportFilterList = false;
// ................... Get iso-material filte list .......................

export const GetIsoMaterialFilterList = (ProjectId, type) => async (dispatch) => {
    if (isFetchingIsoMaterialFilterList) return;
    isFetchingIsoMaterialFilterList = true;
    dispatch(fetchIsoMaterialFilterListStart());
    try {
      const response = await axiosInstance.get(ISO_MATERIAL_FORM_LIST_FILTER, {
        params: { project_id: ProjectId, type: type },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(
        fetchIsoMaterialFilterListSuccess({ type:type, data: response.data.result })
      );
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      dispatch(fetchIsoMaterialFilterListFailure({ error: error.message }));
    } finally {
      isFetchingIsoMaterialFilterList = false;
    }
  };

// ...................... Get Welding Machine Filter List ................................

export const GetWeldingMachineFilterList =
  (ProjectId, type) => async (dispatch) => {
    if (isFetchingWeldingMachineFilterList) return;
    isFetchingWeldingMachineFilterList = true;
    dispatch(fetchWeldingMachineFilterListStart());
    try {
      const response = await axiosInstance.get(
        WELDING_MACHINE_FORM_LIST_FILTER,
        {
          params: { project_id: ProjectId, type: type },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(
        fetchWeldingMachineFilterListSuccess({
          type:type,
          data: response.data.result,
        })
      );
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      dispatch(fetchWeldingMachineFilterListFailure({ error: error.message }));
    } finally {
      isFetchingWeldingMachineFilterList = false;
    }
  };

//   ...................... Get Weld Log Filter List ................................

export const GetWeldLogFilterList = (ProjectId, type) => async (dispatch) => {
  if (isFetchingWeldLogFilterList) return;
  isFetchingWeldLogFilterList = true;
  dispatch(fetchWeldLogFilterListStart());
  try {
    const response = await axiosInstance.get(WELD_LOG_FORM_LIST_FILTER, {
      params: { project_id: ProjectId, type: type },
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch dashboard details.");
    }
    dispatch(
      fetchWeldLogFilterListSuccess({
        type:type,
        data: response.data.result,
      })
    );
  } catch (error) {
    console.error("Error fetching dashboard details:", error);
    dispatch(fetchWeldLogFilterListFailure({ error: error.message }));
  } finally {
    isFetchingWeldLogFilterList = false;
  }
};

// ................... Get Welding WPQ filte list .......................

export const GetWeldingWPQFilterList =
  (ProjectId, type) => async (dispatch) => {
    if (isFetchingWeldingWPQFilterList) return;
    isFetchingWeldingWPQFilterList = true;
    dispatch(fetchWeldingWPQFilterListStart());
    try {
      const response = await axiosInstance.get(WELDING_WPQ_FORM_LIST_FILTER, {
        params: { project_id: ProjectId, type: type },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(
        fetchWeldingWPQFilterListSuccess({ type:type, data: response.data.result })
      );
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      dispatch(fetchWeldingWPQFilterListFailure({ error: error.message }));
    } finally {
      isFetchingWeldingWPQFilterList = false;
    }
  };

// ...................... Get Welding Gas Filter List ................................

export const GetWeldingGasFilterList =
  (ProjectId, type) => async (dispatch) => {
    if (isFetchingWeldingGasFilterList) return;
    isFetchingWeldingGasFilterList = true;
    dispatch(fetchWeldingGasFilterListStart());
    try {
      const response = await axiosInstance.get(WELDING_GAS_FORM_LIST_FILTER, {
        params: { project_id: ProjectId, type: type },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(
        fetchWeldingGasFilterListSuccess({
          type: type,
          data: response.data.result,
        })
      );
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      dispatch(fetchWeldingGasFilterListFailure({ error: error.message }));
    } finally {
      isFetchingWeldingGasFilterList = false;
    }
  };


//   ...................... Get NCR ReportFilter List ................................

export const GetNcrReportFilterList = (ProjectId, type) => async (dispatch) => {
  if (isFetchingNcrReportFilterList) return;
  isFetchingNcrReportFilterList = true;
  dispatch(fetchNcrReportFilterListStart());
  try {
    const response = await axiosInstance.get(NCR_REPORT_FORM_LIST_FILTER, {
      params: { project_id: ProjectId, type: type },
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch dashboard details.");
    }
    dispatch(
      fetchNcrReportFilterListSuccess({
        type:type,
        data: response.data.result,
      })
    );
  } catch (error) {
    console.error("Error fetching dashboard details:", error);
    dispatch(fetchNcrReportFilterListFailure({ error: error.message }));
  } finally {
    isFetchingNcrReportFilterList = false;
  }
};


//   ...................... Get Project Repoort Filter List ................................

export const GetProjectReportFilterList = (ProjectId, type) => async (dispatch) => {
  if (isFetchingProjectReportFilterList) return;
  isFetchingProjectReportFilterList = true;
  dispatch(fetchProjectReportFilterListStart());
  try {
    const response = await axiosInstance.get(PROJECT_REPORT_FORM_LIST_FILTER, {
      params: { project_id: ProjectId, type: type },
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch dashboard details.");
    }
    dispatch(
      fetchProjectReportFilterListSuccess({
        type:type,
        data: response.data.result,
      })
    );
  } catch (error) {
    console.error("Error fetching dashboard details:", error);
    dispatch(fetchProjectReportFilterListFailure({ error: error.message }));
  } finally {
    isFetchingProjectReportFilterList = false;
  }
};
